import $ from 'jquery';
import gsap from "gsap/dist/gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.arrive(".tecniche", {existing: true}, function (){

  gsap.to(".img-container", {
    duration: 2,
    scrollTrigger: {
      trigger: ".img-container",
      start: "top center",
      toggleClass: 'no-opacity',
    }
  })

  gsap.to(".img-container-2", {
    duration: 2,
    scrollTrigger: {
      trigger: ".img-container-2",
      toggleClass: "no-opacity",
    }
  })

  gsap.to(".tecniche-description", {
    x: 30,
    duration: 1,
    scrollTrigger: {
      trigger: ".tecniche-description",
      toggleClass: "no-opacity",
      toggleActions: "restart none resume none",
    }
  })

  gsap.to(".section-title h2", {
    x: 30,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: ".section-title",
      toggleActions: "restart none resume none"
    }
  })
})